import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as HttpConst from './mixin/HttpConst';
import * as CurrencyUtil from './mixin/CurrencyUtil';
import * as SatoshiUtil from './mixin/SatoshiUtil';
import * as CryptoUtil from './mixin/CryptoUtil';
import * as LangUtil from './mixin/LangUtil';
import * as AppUtil from './mixin/AppUtil';
import * as AppConst from './mixin/AppConst';
import VueClipboard from 'vue-clipboard2'
import Meta from 'vue-meta'
import GAuth from 'vue-google-oauth2'
import i18n from './i18n'

Vue.prototype.$httpConst = HttpConst;
Vue.prototype.$currencyUtil = CurrencyUtil;
Vue.prototype.$satoshiUtil = SatoshiUtil;
Vue.prototype.$cryptoUtil = CryptoUtil;
Vue.prototype.$langUtil = LangUtil;
Vue.prototype.$appUtil = AppUtil;
Vue.prototype.$appConst = AppConst.appFunc;

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(Meta)

// 구글로그인
const gauthOption = {
  clientId: '174369004918-e761pcpuvdokq0nqi0siqjm1qc5jtg4q.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
